module.exports = __webpack_public_path__ + "img/personagem-full.1fee7f41.png";